import { IndexMetadata, IndexTypeKeywordSummary } from 'generated/graphql';

export const isSnippetKeywordSummary = (
  snippet?: IndexMetadata,
): snippet is IndexTypeKeywordSummary => {
  return snippet?.__typename === 'IndexTypeKeywordSummary';
};
